<div class="wrapper">
  <clr-dropdown class="signpost" clrDropdownTrigger>
    <div class="action">
      <div [id]="id + '-signpost'" class="icon"></div>
    </div>
    <clr-dropdown-menu
      *clrIfOpen
      class="popup"
      [clrPosition]="position"
      [style.height.rem]="currentHeight"
      [style.width.rem]="minWidth"
    >
      <daui-scroll-viewer [hasLayoutOptimizationTrigger]="false">
        <div #content class="content" (dauiResize)="onResize($event)">
          <ng-content></ng-content>
        </div>
      </daui-scroll-viewer>
    </clr-dropdown-menu>
  </clr-dropdown>
</div>
